// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { reviver: articleReviver } = require('client-v2/common/models/article/record')
const { keyedReviver } = require('client-v2/common/state/revivers')
const { FetchStateEnum } = require('client-v2/common/utils/enums')

class ContentAddModalRecord extends Immutable.Record({
  anchorId: null,
  article: null,
  articleState: FetchStateEnum.EMPTY,
  isAddedToProfile: Boolean(),
  isCollectionsModalVisible: Boolean(),
  isSubmitPending: Boolean(),
  isUrlInvalid: Boolean(),
  isVisible: Boolean(),
  postHref: String(),
  url: String()
}) {

  setArticle(value) {
    return value
    ? this.set('article', Immutable.fromJS(value, articleReviver))
    : this.delete('article')
  }

}

ContentAddModalRecord.reviver = keyedReviver(ContentAddModalRecord, {
  article: articleReviver
})

module.exports = ContentAddModalRecord
